import script from "./CompareTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareTable.vue?vue&type=script&setup=true&lang=js"

import "./CompareTable.vue?vue&type=style&index=0&id=c1e21b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1e21b72"]])

export default __exports__